<template>
  <div>
    <div v-if="(displayButtons.length > 1 || forceDropDown) && hasButton" v-on:mouseenter="buttonListHover"
         @click.prevent.stop=""
         class="dropdown is-hoverable is-right"
         :class="{'is-up':isOpenUp}">
      <div class="dropdown-trigger">
        <button class="button" :class="classes ? classes : 'is-small is-circle'" aria-haspopup="true" aria-controls="dropdown-menu">
          <i class="far" :class="iconClass"></i>
        </button>
      </div>
      <div v-if="canDropDown" class="dropdown-menu" role="menu">
        <div class="dropdown-content has-text-left">
        <span v-for="(b, i) in displayButtons" :key="i">
          <router-link v-if="b.routeName" :to="{name: b.routeName, params: {id: getId()}}" class="dropdown-item">
            <span class="icon"><i class="fal" :class="b.icon"></i></span> {{ b.text }}
          </router-link>
          <a v-else @click.prevent.stop="b.action(getId(), data)" class="dropdown-item">
            <span class="icon"><i class="fal" :class="b.icon"></i></span> {{ b.text }}
          </a>
        </span>
        </div>
      </div>
    </div>
    <span v-on:mouseenter="buttonListHover" v-else-if="displayButtons.length === 1">
      <router-link v-if="displayButtons[0].routeName" :to="{name: displayButtons[0].routeName, params: {id: getId()}}"
                   class="button" :class="classes ? classes : 'is-circle'">
        <span class="icon"><i class="fal" :class="displayButtons[0].icon"></i></span>
      </router-link>
      <a v-else @click.prevent.stop="displayButtons[0].action(getId(), data)" class="button" :class="classes ? classes : 'is-circle'">
        <span class="icon"><i class="fal" :class="displayButtons[0].icon"></i></span> <!-- {{ displayButtons[0].text }} -->
      </a>
    </span>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'DisplayButtonList',
    props: {
      buttons: {
        type: [Array, Object],
        required: true
      },
      forceDropDown: {
        type: Boolean,
        default: false
      },
      canDropDown: {
        type: Boolean,
        default: true
      },
      idAttr: {
        type: String,
        default: 'pk'
      },
      data: {
        type: [String, Object],
        required: true
      },
      iconClass: {
        type: String,
        default: 'fa-ellipsis-v'
      },
      classes: String,
      openUp: {
        type: [Object, Boolean],
        required: false,
        default: false
      }
    },
    computed: {
      ...mapGetters(['currentUserProfil']),
      displayButtons () {
        const bs = []
        this.buttons.forEach(b => {
          let disabled = false

          b.disabled = disabled
          let display = true
          if (b.display && typeof b.display === 'function') {
            display = b.display(this.data)
          } else if (b.display === false) {
            display = b.display
          }
          if (display && (!b.needProfile || b.needProfile.includes(this.currentUserProfil))) {
            bs.push(b)
          }
        })
        return bs
      },
      hasButton () {
        return this.buttons.filter(el => {
          if (el.display && typeof el.display === 'function') {
            return el.display && el.display(this.data) === true
          } else return true
        }).length
      },
      isOpenUp () {
        if (!this.openUp) return false
        if (this.openUp.position >= 3 && this.openUp.position >= this.openUp.total - 2) return true
        return false
      }
    },
    methods: {
      buttonListHover () {
        this.$emit('hover')
      },
      getId () {
        if (typeof this.data === 'string') {
          return this.data
        }
        return this.data[this.idAttr]
      }
    }
  }
</script>

<style>
  a.disabled {
    pointer-events: none;
    opacity: 0.3;
  }
   /*
  .dropdown-item {
   color: #919191 !important;
   text-decoration: none !important;
  }
  .dropdown-item:hover {
    background-color: transparent;
    color: #242424 !important;
  }*/
</style>



// WEBPACK FOOTER //
// src/components/utils/DisplayButtonList.vue